module.exports = __webpack_public_path__ + "media/Homevignette@2x.3c3fc80a.png";